/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Canvas2DRenderGraph from "App/render/canvas/render_graph";
import Canvas2DContext from "App/canvas_2d_context";
import {vec4} from "gl-matrix";
import Factory from "App/render/canvas/nodes/bins/factory";
import {FrustumVolume} from "App/utils/view_frustum";
import {project} from "App/utils/glu";
import View from "App/view/view";
import IScene from "js_interface/src/scene_interface";
//@ts-ignore
import {CameraTypeEnum} from "js_interface/src/modules/view_controls/scene_view_controls_enums.ts";

export default
class WebVRHUD {

    public static TypeName: string = "WebVRHUD";

    private _sceneAPI: IScene;

    private _renderGraph: Canvas2DRenderGraph;
    private _context: Canvas2DContext;

    private _drawMovingDirectionHint = false;
    private _pgc: any;

    constructor(aSceneAPI: IScene, aRenderGraph: Canvas2DRenderGraph) {
        this._sceneAPI = aSceneAPI;

        this._renderGraph = aRenderGraph;
        this._context = <Canvas2DContext> aRenderGraph.getContext();

        this._pgc = {
            windowPoint: vec4.create()
        };
    }

    public static create(aSceneAPI: IScene, aRenderGraph: Canvas2DRenderGraph): WebVRHUD {
        return new WebVRHUD(aSceneAPI, aRenderGraph);
    }

    public isEmpty(): boolean {
        return this._drawMovingDirectionHint === false;
    }

    public drawMovingDirectionHint(aValue: boolean) {
        this._drawMovingDirectionHint = aValue;
    }

    public addShape(aShape: Object): boolean {
        return true;
    }

    public removeShape(aShape: Object): boolean {
        return false;
    }

    public render(aView: View) {
        let camera = aView.getCamera();

        if (camera.getCameraType() !== CameraTypeEnum.WEBVR) {
            return;
        }

        if (this._drawMovingDirectionHint) {
            this._drawMovingDirection(aView);
        }
    }

    private _drawMovingDirection(aView: View) {
        let camera = aView.getCamera();

        let cameraTarget = camera.getCameraTarget();

        let mvp = camera.getViewProjectionMatrix();

        let visible = FrustumVolume.containsPoint(mvp, cameraTarget);
        if (visible) {

            let windowPoint = this._pgc.windowPoint;
            let position = aView.getPosition();
            let size = aView.getSize();
            project(windowPoint, cameraTarget, aView.getCamera().getViewProjectionMatrix(), [position[0], position[1], size[0], size[1]]);
            windowPoint[0] = windowPoint[0];
            windowPoint[1] = size[1] - 1 - windowPoint[1];

            let ctx = this._context.getRenderingContext();
            ctx.beginPath();
            ctx.arc(windowPoint[0], windowPoint[1], 3, 0, 2 * Math.PI, false);
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'rgba(' + Math.floor(0.0) + ',' + Math.floor(0.0) + ',' + Math.floor(0.0) + "," + 0.5 + ')';
            ctx.stroke();
        }
    }
}

Factory.register(WebVRHUD);
